import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import qs from 'qs';
import {
  Dropdown,
  Form,
  Grid,
  Label,
  Menu,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { required } from '@mhub/web-validations';
import { connect } from 'react-redux';
import AppForm from '../../../components/AppForm';
import { fetchM } from '../../../actions/fetchM';
import { flashErrorMessage } from '../../../actions/flash';
import SpecificationTable from '../../../components/SpecificationTable';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { translateModels } from '../../../utils/translation';
import { isVietnamCountryCode } from '../../../utils/areaLabel';
import { parseLayoutFormValues, VN_LAYOUT_DEFAULT_VALUES } from '../../../utils/unitLayout';

class UnitLayoutForm extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    projectID: PropTypes.string,
    onChange: PropTypes.func,
    auth: PropTypes.shape({
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    unitLayout: PropTypes.shape({
      name: PropTypes.string,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
      hash: PropTypes.string,
    }),
    loading: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultValues = {
    projectID: '',
    name: '',
    size: 0,
    landArea: 0,
    specifications: [],
    overview: '',
    pictureID: '',
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    const unitLayout = Object.assign({}, this.defaultValues(), props.unitLayout || {});
    let currentTab = this.tabs[0].name;
    if (props.location && props.location.hash.length > 0) {
      currentTab = props.location.hash.replace('#', '');
    }
    const menuIsTab = window.innerWidth < 425;
    const menuIsVertical = window.innerWidth >= 768;
    this.state = {
      unitLayout,
      oriUnitLayout: clone(unitLayout),
      errMessages: [],
      currentTab,
      menuIsTab,
      menuIsVertical,
      pictures: [],
      loadingPictures: false,
    };
    this.validation = {
      name: createRef(),
      virtualTourURL: createRef(),
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    if (this.props.projectID && this.isVietnam()) {
      this.fetchProjectPictures();
    }
  }
  componentWillReceiveProps(nextProps) {
    let unitLayout = Object.assign({}, this.defaultValues(), this.state.unitLayout);
    let oriUnitLayout = this.state.oriUnitLayout;
    if (JSON.stringify(this.props.unitLayout) !== JSON.stringify(nextProps.unitLayout)) {
      unitLayout = Object.assign(unitLayout, nextProps.unitLayout);
      oriUnitLayout = clone(unitLayout);
    }
    let currentTab = this.state.currentTab;
    if (nextProps.location && nextProps.location.hash.length > 0) {
      currentTab = nextProps.location.hash.replace('#', '');
    }
    this.setState({
      unitLayout,
      oriUnitLayout,
      currentTab,
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  isVietnam() {
    const company = (this.props.auth && this.props.auth.company) || {};
    return isVietnamCountryCode(company.countryCode);
  }
  // CPI-1208: the six Vietnam-only fields are merged in only for a Vietnamese company.
  defaultValues() {
    return this.isVietnam()
      ? Object.assign({}, UnitLayoutForm.defaultValues, VN_LAYOUT_DEFAULT_VALUES)
      : UnitLayoutForm.defaultValues;
  }
  async fetchProjectPictures() {
    const { store } = this.context;
    const query = { types: ['unit_layout'], limit: 0 };
    this.setState({ loadingPictures: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.projectID}/pictures/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      this.setState({ loadingPictures: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      this.setState({ loadingPictures: false });
      return;
    }
    const pictures = await res.json();
    this.setState({
      loadingPictures: false,
      pictures: pictures ? pictures.map(picture => ({
        key: picture.id,
        text: picture.label && picture.label.trim().length > 0 ? picture.label : picture.id,
        value: picture.id,
      })) : [],
    });
  }
  handleResize = () => {
    const state = {};
    const menuIsTab = window.innerWidth < 425;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const menuIsVertical = window.innerWidth >= 768;
    if (menuIsVertical !== this.state.menuIsVertical) {
      state.menuIsVertical = menuIsVertical;
    }
    this.setState({ ...state });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { unitLayout } = this.state;
    if (unitLayout.specifications) {
      unitLayout.specifications = unitLayout.specifications.filter(data =>
        data.name.length > 0 && data.value.length > 0).map((data, idx) => ({
          ...data,
          position: idx + 1,
        }));
    }
    AppForm.validate(this.validation, unitLayout)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        const data = parseLayoutFormValues(unitLayout, this.isVietnam());
        this.props.onSubmit(validations, data);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleInputChange = (event, data) => {
    const { unitLayout } = this.state;
    unitLayout[data.name] = data.value;
    this.setState({ unitLayout }, () => {
      this.handleCheckChanges();
    });
  }
  handleSpecificationsChange = (data) => {
    const { unitLayout } = this.state;
    unitLayout.specifications = data;
    this.setState({ unitLayout }, () => {
      this.handleCheckChanges();
    });
  }
  tabs = [
    {
      name: 'info',
      value: 'info',
      text: 'Info',
      fields: ['name'],
    },
    {
      name: 'specifications',
      value: 'specifications',
      text: 'Specifications',
      fields: [],
    },
    {
      name: 'virtual_tour',
      value: 'virtual_tour',
      text: 'Virtual Tour',
      fields: [],
    },
  ];
  handleChangeTab = (e, { name, value }) => {
    const currentTab = name || value;
    this.setState({ currentTab });
  }
  checkActiveTab(name) {
    return this.state.currentTab === name ? '' : 'hidden';
  }
  render() {
    const { t } = this.props;
    const isVietnam = this.isVietnam();
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Grid.Row>
            <Grid.Column width={4}>
              <Menu
                fluid
                widths={this.state.menuIsTab ? 1 : null}
                tabular={!this.state.menuIsTab}
                vertical={this.state.menuIsVertical}
              >
                {
                  this.state.menuIsTab ?
                    <Dropdown
                      item
                      selectOnBlur={false}
                      options={this.tabs.map(tab => ({
                        text: t(tab.text),
                        name: tab.name,
                        value: tab.value,
                        label: this.state.errMessages.some(e => tab.fields.some(f => e.key === f)) ?
                        {
                          color: 'red',
                          content: '!',
                        } : null,
                      }))}
                      onChange={this.handleChangeTab}
                      value={this.state.currentTab}
                      disabled={this.props.loading}
                    />
                    : this.tabs.map((tab, key) => (
                      <Menu.Item
                        key={key}
                        name={tab.name}
                        onClick={this.handleChangeTab}
                        active={this.state.currentTab === tab.name}
                      >
                        {t(tab.text)}
                        {
                          this.state.errMessages.some(e => tab.fields.some(f => e.key === f)) ?
                            <Label color="red" floating={!this.state.menuIsVertical} content="!" />
                          : null
                        }
                      </Menu.Item>
                    ))
                }
              </Menu>
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('info')}>
              <AppForm.Input
                label={translateModels(t, 'name', 'projectUnitLayout')}
                name="name"
                value={this.state.unitLayout.name}
                onChange={this.handleInputChange}
                ref={this.validation.name}
                validation={[required]}
              />
              {/* CPI-1208: a Vietnamese layout records Block, Direction, View and Floor as free
                  text (D6) and its two areas as NFA and NSA; Build Up Area and Land Area belong to
                  the Malaysian layout and are not shown for Vietnam. Every other company renders
                  the two inputs below exactly as it did before. */}
              {isVietnam ? (
                <React.Fragment>
                  <AppForm.Input
                    label={translateModels(t, 'block', 'projectUnitLayout')}
                    name="block"
                    value={this.state.unitLayout.block}
                    onChange={this.handleInputChange}
                  />
                  <AppForm.Input
                    label={translateModels(t, 'direction', 'projectUnitLayout')}
                    name="direction"
                    value={this.state.unitLayout.direction}
                    onChange={this.handleInputChange}
                  />
                  <AppForm.Input
                    label={translateModels(t, 'view', 'projectUnitLayout')}
                    name="view"
                    value={this.state.unitLayout.view}
                    onChange={this.handleInputChange}
                  />
                  <AppForm.Input
                    label={translateModels(t, 'floor', 'projectUnitLayout')}
                    name="floor"
                    value={this.state.unitLayout.floor}
                    onChange={this.handleInputChange}
                  />
                  <AppForm.Input
                    label={translateModels(t, 'nfa', 'projectUnitLayout')}
                    type="number"
                    step="0.0001"
                    name="nfa"
                    value={this.state.unitLayout.nfa}
                    onChange={this.handleInputChange}
                  />
                  <AppForm.Input
                    label={translateModels(t, 'nsa', 'projectUnitLayout')}
                    type="number"
                    step="0.0001"
                    name="nsa"
                    value={this.state.unitLayout.nsa}
                    onChange={this.handleInputChange}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <AppForm.Input
                    label={translateModels(t, 'size', 'projectUnitLayout')}
                    type="number"
                    step="0.0001"
                    name="size"
                    value={this.state.unitLayout.size}
                    onChange={this.handleInputChange}
                  />
                  <AppForm.Input
                    label={translateModels(t, 'landArea', 'projectUnitLayout')}
                    type="number"
                    step="0.0001"
                    name="landArea"
                    value={this.state.unitLayout.landArea}
                    onChange={this.handleInputChange}
                  />
                </React.Fragment>
              )}
              <Form.TextArea
                label={translateModels(t, 'overview', 'projectUnitLayout')}
                name="overview"
                value={this.state.unitLayout.overview}
                onChange={this.handleInputChange}
              />
              {isVietnam && (
                <Form.Select
                  label={translateModels(t, 'pictureID', 'projectUnitLayout')}
                  name="pictureID"
                  search
                  fluid
                  clearable
                  selectOnBlur={false}
                  placeholder={t('Select picture', { ns: TRANSLATION_FILES.screens })}
                  value={this.state.unitLayout.pictureID || ''}
                  options={this.state.pictures}
                  loading={this.state.loadingPictures}
                  onChange={this.handleInputChange}
                />
              )}
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('specifications')}>
              <SpecificationTable
                type="unit_layouts"
                editable
                isEditing
                hideButton
                data={this.state.unitLayout.specifications}
                onChange={this.handleSpecificationsChange}
                loading={this.props.loading}
              />
            </Grid.Column>
            <Grid.Column stretched className={this.checkActiveTab('virtual_tour')}>
              <AppForm.Input
                label="URL"
                name="virtualTourURL"
                value={this.state.unitLayout.virtualTourURL}
                onChange={this.handleInputChange}
                ref={this.validation.virtualTourURL}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}


export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.projectUnitLayout,
], { withRef: true })(
  connect(UnitLayoutForm.mapStateToProps, null, null, { withRef: true })(UnitLayoutForm),
);



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayouts/Form.jsx